import { render, staticRenderFns } from "./dictValueEditor.vue?vue&type=template&id=3c0d450e&scoped=true"
import script from "./dictValueEditor.vue?vue&type=script&lang=js"
export * from "./dictValueEditor.vue?vue&type=script&lang=js"
import style0 from "./dictValueEditor.vue?vue&type=style&index=0&id=3c0d450e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0d450e",
  null
  
)

export default component.exports